import { createBrowserRouter, LazyRouteFunction, Navigate, RouteObject } from 'react-router';

import { ExplorerPage } from '@page/explorer/explorer.page';
import { InvitePage } from '@page/invite/invite.page';
import { NotFoundPage } from '@page/not-found/not-found.page';
import { RequestExternalIntegrationPage } from '@page/request-external-integration/request-external-integration.page';
import { VerifyPage } from '@page/verify/verify.page';

import { MainLayout } from '@component/layout/main/main-layout';
import { RouteEnum } from '@enum/route.enum';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { pageLazyLoader } from '@util/route/page-lazy-loader';
import { pageNameLoader } from '@util/route/page-name-loader';

import { ApplicationsRoutes } from './applications/applications.routes';
import { BillingRoutes } from './billing/billing.routes';
import { ConnectorRoutes } from './connector/connector.routes';
import { ConsumerRoutes } from './consumer/consumer.routes';
import { SafeRoutes } from './safe/safe.routes';
import { UnsafeRoutes } from './unsafe/unsafe.routes';

const mainRoutes: RouteConfigInterface[] = [
  ...SafeRoutes,
  ...BillingRoutes,
  ...ApplicationsRoutes,
  ...ConsumerRoutes,
  ...ConnectorRoutes,
  ...UnsafeRoutes,
];

export const appRouter = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to={RouteEnum.Dashboard.path} replace />,
  },
  {
    ...pageNameLoader(RouteEnum.Explorer),
    element: <ExplorerPage />,
  },
  {
    ...pageNameLoader(RouteEnum.RequestExternalIntegration),
    element: <RequestExternalIntegrationPage />,
  },
  {
    ...pageNameLoader(RouteEnum.Invite),
    element: <InvitePage />,
  },
  {
    ...pageNameLoader(RouteEnum.Verify),
    element: <VerifyPage />,
  },
  {
    lazy: (() => pageLazyLoader(import('@component/route/protected.route'))) as LazyRouteFunction<RouteObject>,
    children: [
      {
        lazy: (() =>
          pageLazyLoader(import('@component/route/init-app/init-app.route'))) as LazyRouteFunction<RouteObject>,
        children: [
          {
            element: <MainLayout />,
            children: mainRoutes,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
